"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateQuery = void 0;
// Based on the generated query
exports.templateQuery = `
template {
  title
  applicationTitle
  description
  type
  locale
  version
  lastUpdated
  applicability {
    prompts {
      id
      label {
        label
        text
      }
      context {
        label
        text
      }
      hint {
        label
        text
      }
      responseType
      rating1
      rating2
      rating3
      rating4
      rating5
      responseSelections {
        selectionDescription
        selections {
          selectionLabel
          selectionId
        }
      }
    }
  }
  metadataConfig {
    excludeOptionalMetadataKeys
    requiredMetadataKeys
    customMetadata {
      key
      keyName
      keyDescription
      valueType
      valueHint
      defaultValue
      responseSelections {
        selectionDescription
        selections {
          selectionLabel
          selectionId
        }
      }
    }
  }
  defaults {
    userQuestionnaires {
      preEvent {
        enabled
        questions {
          optionToSendAll
          excludeSections
          questionType
        }
        sponsorEmailTemplate {
          subject
          body
        }
        participantEmailTemplate {
          subject
          body
        }
      }
    }
    questionnaireAnswers {
      perspective
      questionContextLabel
      questionLabel
      useQuestionRatingStratum
      ratingBands {
        color
        lowerBound
        upperBound
        title
        description
      }
      rating1
      rating1Disabled
      rating1Title
      rating1Value
      rating1Color
      rating2
      rating2Disabled
      rating2Title
      rating2Value
      rating2Color
      rating3
      rating3Disabled
      rating3Title
      rating3Value
      rating3Color
      rating4
      rating4Disabled
      rating4Title
      rating4Value
      rating4Color
      rating5
      rating5Disabled
      rating5Title
      rating5Value
      rating5Color
      ratingNA
      ratingNATitle
      ratingNAValue
      ratingNAEnabled
      ratingNAColor
      ratingIncompleteColor
      showGuidance
      useQuestionIndex
      minAnswersToScore
      wbsEnabled
      questionTypeEnabled
      metadataConfig {
        customMetadata {
          key
          keyName
          keyDescription
          valueType
          valueHint
          defaultValue
          responseSelections {
            selectionDescription
            selections {
              selectionLabel
              selectionId
            }
          }
        }
      }
    }
    report {
      sectionLabel
      report {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      heatmap {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      scoreBarChart {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      radar {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      snapshots {
        title
        description
        context
        disabled
      }
      ppt {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      excel {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      word {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
      scores {
        maxRating
        perspectiveWeighted
        equalCategoryWeight
        summaryAssessment {
          name
          resultCriteria {
            summary
            description
            ratingRange
          }
        }
      }
      responseDistribution {
        title
        description
        context
        type
        groupBy
        categoryLabel
        sectionLabel
        excludeSections
        useQuestionIndex
        disabled
      }
    }
  }
  sections {
    id
    label
    showIfAnswerYes
    categories {
      id
      name
      abbreviation
      ability {
        label
        text
      }
      driver {
        label
        text
      }
      prescribedActions {
        label
        text
      }
      observations {
        observations
        updatedBy
        tags {
          key
          value
        }
      }
      actions {
        actions {
          text
          priority
          effort
          targetDate
          owner
        }
        updatedBy
        tags {
          key
          value
        }
      }
      prompts {
        id
        targetSegmentIds
        label {
          label
          text
        }
        abbreviation {
          label
          text
        }
        context {
          label
          text
        }
        hint {
          label
          text
        }
        workstream {
          name
          activities {
            id
            name
            phase
            prescribedActions {
              label
              text
            }
            observations {
              observations
              updatedBy
              tags {
                key
                value
              }
            }
            actions {
              actions {
                text
                priority
                effort
                targetDate
                owner
              }
              updatedBy
              tags {
                key
                value
              }
            }
            score
            booleanDistribution {
              numYes
              numNo
              numUnknown
            }
          }
          score
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
        }
        dependencyActivity {
          id
          name
          phase
          prescribedActions {
            label
            text
          }
          observations {
            observations
            updatedBy
            tags {
              key
              value
            }
          }
          actions {
            actions {
              text
              priority
              effort
              targetDate
              owner
            }
            updatedBy
            tags {
              key
              value
            }
          }
          score
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
        }
        responseType
        rating1
        rating2
        rating3
        rating4
        rating5
        questionType
        responseSelections {
          selectionDescription
          selections {
            selectionLabel
            selectionId
          }
        }
        priority
        response {
          ... on AssessmentResponseText {
            stringValue
            priority
            updatedBy
          }
          ... on AssessmentResponseRating {
            intValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseBoolean {
            booleanValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseNumber {
            intValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseSingleSelection {
            singleSelectValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseMultiSelection {
            multiSelectValues
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseDate {
            dateValue
            priority
            comments
            updatedBy
          }
        }
        metadata {
          key
          value
        }
      }
      score
      weightedScore
      booleanDistribution {
        numYes
        numNo
        numUnknown
      }
    }
    abbreviation
    percentWeight
    score
    weightedScore
    booleanDistribution {
      numYes
      numNo
      numUnknown
    }
  }
  workstreams {
    name
    id
    accelerator
    activities {
      id
      name
      phase
      prescribedActions {
        label
        text
      }
      observations {
        observations
        updatedBy
        tags {
          key
          value
        }
      }
      actions {
        actions {
          text
          priority
          effort
          targetDate
          owner
        }
        updatedBy
        tags {
          key
          value
        }
      }
      prompts {
        id
        targetSegmentIds
        label {
          label
          text
        }
        context {
          label
          text
        }
        hint {
          label
          text
        }
        workstream {
          name
          activities {
            id
            name
            phase
            prescribedActions {
              label
              text
            }
            observations {
              observations
              updatedBy
              tags {
                key
                value
              }
            }
            actions {
              actions {
                text
                priority
                effort
                targetDate
                owner
              }
              updatedBy
              tags {
                key
                value
              }
            }
            score
            booleanDistribution {
              numYes
              numNo
              numUnknown
            }
          }
          score
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
        }
        dependencyActivity {
          id
          name
          phase
          prescribedActions {
            label
            text
          }
          observations {
            observations
            updatedBy
            tags {
              key
              value
            }
          }
          actions {
            actions {
              text
              priority
              effort
              targetDate
              owner
            }
            updatedBy
            tags {
              key
              value
            }
          }
          score
          booleanDistribution {
            numYes
            numNo
            numUnknown
          }
        }
        responseType
        rating1
        rating2
        rating3
        rating4
        rating5
        questionType
        responseSelections {
          selectionDescription
          selections {
            selectionLabel
            selectionId
          }
        }
        priority
        response {
          ... on AssessmentResponseText {
            stringValue
            priority
            updatedBy
          }
          ... on AssessmentResponseRating {
            intValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseBoolean {
            booleanValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseNumber {
            intValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseSingleSelection {
            singleSelectValue
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseMultiSelection {
            multiSelectValues
            priority
            comments
            updatedBy
          }
          ... on AssessmentResponseDate {
            dateValue
            priority
            comments
            updatedBy
          }
        }
        metadata {
          key
          value
        }
      }
      score
      booleanDistribution {
        numYes
        numNo
        numUnknown
      }
    }
    score
    booleanDistribution {
      numYes
      numNo
      numUnknown
    }
  }
  progress
  deliveryGuidance {
    description
    learnMore
  }
  booleanDistribution {
    numYes
    numNo
    numUnknown
  }
}
`;
